import axios from "axios";
import qs from "querystring";
import util from "@/assets/js/common/util";
// let tokens = [
//   "Ru09RtNrMGOXUKSxVkb88gr9rMZ27bCYaFbpaEHa",
//   "lEgMj8DbvmH4J9IBWdiPxWSXfrPoZ4TkDYb54XAS",
// ];
let tokens = "GBM8wIDL22Ct0u2EyoUPvufsnSGnc7VpSiXgjQJM";
const service = axios.create({
  baseURL: "/yuqueapi/",
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
    "X-Auth-Token": tokens,
  },
});
function post(url, params, isJson) {
  return new Promise((resolve, reject) => {
    const param = isJson ? params : qs.stringify(params);
    service
      .post(url, param)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}

/// /返回一个Promise(发送get请求)
// 因为new Promise声明的是异步函数，而且是为了ajax请求嵌套严重，而更加规范的一种书写方式;这里将Promise作为返回值给我们的公用函数
function get(rawUrl, params) {
  const url =
    rawUrl.indexOf("?") < 0
      ? rawUrl + "?_=" + new Date().getTime()
      : 'rawUrl + "&_=" + (new Date()).getTime()';
  return new Promise((resolve, reject) => {
    service
      .get(url, { params })
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
const request = {
  get,
  post,
  axios,
};
export default request;
